// CORE Polyfills
import 'whatwg-fetch';
import '~utilities/polyfill/prepend';
import '~utilities/polyfill/closest';
import '~utilities/polyfill/custom-elements';
import '~utilities/polyfill/find';
import '~utilities/polyfill/remove';

// Fonts (only if you're not using the SCSS files)
// NOTE: Change the .npmrc pro licence
// import '@fortawesome/fontawesome-pro/js/all.js';

// Router
import '~routes/router';

// CORE Utilities
import '~utilities/get-service-worker';
import '~utilities/keyboard-focus';
import '~utilities/detect-touch';
import '~utilities/detect-breakpoints';
import AsyncLoad from '~utilities/async-load';
import InitializeScript from '~utilities/initialize-script';
import RemoveBreaks from '~utilities/remove-breaks';
import ScrollToLink from '~utilities/scroll-to-link';
import InAnimation from '~utilities/in-animation';
import Sticky from '~utilities/sticky';
import AsyncElement from '~utilities/async-element';

// CORE Development
import Styleguide from '~development/styleguide/js';
import Devbar from '~development/devbar/js';

// CORE Components
import Form from '~components/form/js';
import BypassNavigation from '~components/bypass-navigation/js';
import Modal from '~components/modal/js';
import Tab from '~components/tab/js';
import Accordion from '~components/accordion/js';
import Tabcordion from '~components/tabcordion/js';
import Tooltip from '~components/tooltip/js';
import Image from '~components/image/js';
import Toast from '~components/toast/js';
import Filter from '~components/filter/js';
import AdvancedFilter from '~components/advanced-filter/js';
import Loader from '~components/loader/js';
import Breadcrumb from '~components/breadcrumb/js';
import ContrastButton from '~components/contrast-button/js';
import CustomPlayer from '~components/custom-player/js';
import Carousel from '~components/carousel/js';


// Utilities
import WindowApp from 'utilities/window-app';
import ExternalLinks from 'utilities/external-links';


// Components
// import Example from 'components/example';
import Survey from 'components/survey';
import Prank from 'components/prank';
import ShowMore from 'components/showmore';
import ELearning from 'components/elearning';
import Menu from 'components/menu';

import "@lottiefiles/lottie-player";

onLoad();
window.app = new WindowApp();

// Custom Elements
customElements.define('d-devbar', Devbar);
customElements.define('d-styleguide', Styleguide);
customElements.define('c-loader', Loader);
customElements.define('c-tooltip', Tooltip);
customElements.define('c-modal', Modal);
customElements.define('c-bypass', BypassNavigation);
customElements.define('c-tab', Tab);
customElements.define('c-accordion', Accordion);
customElements.define('c-tabcordion', Tabcordion);
customElements.define('c-filter', Filter);
customElements.define('c-advanced-filter', AdvancedFilter);
customElements.define('c-breadcrumb', Breadcrumb);
customElements.define('c-contrast-button', ContrastButton);
customElements.define('c-custom-player', CustomPlayer);
customElements.define('c-carousel', Carousel);
customElements.define('c-survey', Survey);
customElements.define('c-showmore', ShowMore);
customElements.define('c-elearning', ELearning);
customElements.define('c-toggle-menu', Menu);

customElements.define('u-async-element', AsyncElement);

// Custom Elements Example
// customElements.define('c-example-2', Example2);
customElements.define('c-prank', Prank);


export function onLoad() {
    new ExternalLinks();
    InitializeScript.async('js-remove-breaks', RemoveBreaks);
    InitializeScript.async('js-form', Form);
    InitializeScript.async('js-image', Image);
    InitializeScript.async('js-in-animation', InAnimation);
    InitializeScript.async('js-async-load', AsyncLoad);
    InitializeScript.async('js-toast', Toast);
    InitializeScript.async('js-scroll-to-link', ScrollToLink);
    InitializeScript.async('js-sticky', Sticky);


    // console.log('replace u-external-link');
    // document.querySelectorAll('.u-external-link').forEach(element => {
    //     console.log(element.innerHTML.indexOf('<img'))
    //     if (element.innerHTML.indexOf('<img') >= 0) return;
    //     element.setAttribute('aria-label', `${element.innerHTML} (opent externe website in een nieuw tabblad)`)
    //     element.setAttribute('target', `_new`)
    // })

    // Initialize Script Example
    // InitializeScript.async('js-example', Example);
}
